import { v4 as uuidv4 } from 'uuid';
import { PluginProvider } from '../../../system/providers/plugin';
import i18n from '../../../i18n';
import { CreateVariant } from '../../MasterTabsProvider';
import { typeReport } from '../DashboardBusinessControls/interfaces';
import AnalysisWithoutSalesLotGridPluginSettings from './AnalysisMandatoryAssortmentLotGridPluginSettings';
import AnalysisWithoutSalesLotPluginView from './AnalysisMandatoryAssortmentLotPluginView';
import AnalysisMandatoryAssortmentLotGridPluginSettings from './AnalysisMandatoryAssortmentLotGridPluginSettings';
import AnalysisMandatoryAssortmentLotPluginView from './AnalysisMandatoryAssortmentLotPluginView';

export const AnalysisMandatoryAssortmentLotTab = (variant?: CreateVariant, idGlobal?: string, tabId?: string, contractorName?: string, reportType?: keyof typeof typeReport): ITab => {

    const t = (value: string) => i18n.t("sidePanel." + value);

    const getTabTitle = () => {
        function truncateString(str: string, maxLength: number): string {
            if (!str) return '';
            return str.length > maxLength
                ? `${str.substring(0, maxLength)}...`
                : str;
        }

        if (!reportType) return t("accounting.submenu.analysisMandatoryAssortmentLot");

        switch (reportType) {
            case 'MandatoryAssortmentReport':
                return `Дефицит МОА - ${truncateString(contractorName as string, 25)}`;
            default:
                return t("accounting.submenu.analysisMandatoryAssortmentLot");
        }
    };

    return {
        id: uuidv4(),
        title: getTabTitle(),
        view: {
            content:
                AnalysisMandatoryAssortmentLotGridPluginSettings
                    ? <PluginProvider plugin={AnalysisMandatoryAssortmentLotGridPluginSettings()}>
                        <AnalysisMandatoryAssortmentLotPluginView gridId={uuidv4()} plugin={AnalysisMandatoryAssortmentLotGridPluginSettings()} tabId={tabId} />
                    </PluginProvider>
                    :
                    <p> Справочник не настроен </p>
        }
    }
}

export default AnalysisMandatoryAssortmentLotTab
